// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7fc513d0","920":"566ff55d","928":"e0f31843"}[chunkId] + ".chunk.js";
};